var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"active",attrs:{"id":"progress"}},[_c('div',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"icon icon-home",on:{"click":_vm.onRestart}}),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"bar"},[_c('div',{staticClass:"bar-inner",style:(_vm.style)})])]),_c('div',{staticClass:"icon icon-complete"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }